module.exports = __webpack_public_path__ + "img/Cutomer-icon.54f39968.svg";